import React from 'react'
import { Avatar } from '@deal/components'
import { ProductExpertFragment } from '#src/generated/graphql'
import { ExpertCuratedItemNoteFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface NoteProps {
  note: ExpertCuratedItemNoteFragment
  maybeSellableExpert: ProductExpertFragment
}

const Note: React.SFC<NoteProps> = ({ note, maybeSellableExpert }) => {
  let noteExpert = maybeSellableExpert

  return (
    <div className={styles.wrapper}>
      <div className={styles.expert}>
        <Avatar
          name={noteExpert.displayName}
          src={noteExpert?.expertProfile?.profilePhoto?.url}
          size={44}
        />
        <div className={styles.expertMetadata}>
          <div className={styles.expertName}>{noteExpert.displayName}</div>
          {noteExpert.expertProfile && (
            <div className={styles.expertTitle}>{noteExpert.expertProfile.headline}</div>
          )}
        </div>
      </div>
      <div className={styles.header}>
        Why <span className={styles.firstName}>{noteExpert.shortName}</span> likes this product
      </div>
      <div className={styles.body}>{note.text}</div>
    </div>
  )
}

export default Note
